export default __webpack_public_path__ + "static/media/dentalWelcome.00fd16ab.png";